module.exports = __webpack_public_path__ + "static/media/mob.a7e3ff2a.svg";